import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const defaultData = [
  { name: "Paid", value: 0, color: "#3b82f6" },
  { name: "Pending", value: 0, color: "#d1d5db" },
];

export default function PayrollOverview({ data, isStaff = false }) {
  // Staff doesn't have payroll data, so hide this card
  if (isStaff) {
    return null;
  }

  // Map API data to payroll chart based on actual API response structure
  const paidAmount = data?.payrollOverview?.last_month?.total_net || data?.payrollOverview?.latest_run?.total_net || 0;
  const pendingAmount = data?.payrollOverview?.current_month ?
    (data.payrollOverview.current_month.total_net || 0) : 0;

  const chartData = data?.payrollOverview ? [
    { name: "Paid", value: paidAmount, color: "#3b82f6" },
    { name: "Pending", value: pendingAmount, color: "#d1d5db" },
  ] : defaultData;

  const total = chartData.reduce((sum, item) => sum + item.value, 0);
  const totalSalary = data?.payrollOverview?.year_to_date?.total_net ||
    data?.payrollOverview?.last_month?.total_net ||
    data?.payrollOverview?.latest_run?.total_net ||
    total;

  return (
    <div className="bg-white p-5 rounded-xl border border-borderColor">
      <h3 className="font-semibold text-gray-900 mb-3">Payroll Overview</h3>

      {/* Display numbers */}
      <div className="flex justify-center gap-4 mb-3 text-xs">
        {chartData.map((entry, index) => (
          <div key={index} className="flex items-center gap-1.5">
            <span
              className="w-2.5 h-2.5 rounded-full"
              style={{ backgroundColor: entry.color }}
            ></span>
            <span className="text-gray-500">
              {entry.name}: <span className="font-semibold text-gray-700">₹{entry.value.toLocaleString()}</span>
            </span>
          </div>
        ))}
      </div>

      <ResponsiveContainer width="100%" height={250}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={90}
            paddingAngle={3}
            dataKey="value"
          >
            {chartData.map((entry, idx) => (
              <Cell key={idx} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className="text-center mt-2">
        <h4 className="text-xl font-bold text-gray-900">₹{totalSalary.toLocaleString()}</h4>
        <p className="text-gray-400 text-xs mt-0.5">Total Salary</p>
      </div>
    </div>
  );
}
